import React from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Typography,
  Paper,
  Stack,
  Alert,
} from '@mui/material';
import {
  Warning as WarningIcon,
  Computer as ComputerIcon,
  Security as SecurityIcon,
} from '@mui/icons-material';

interface OnlyOneBrowserModalProps {
  open: boolean;
}

const OnlyOneBrowserModal = ({ open }: OnlyOneBrowserModalProps) => {
  return (
    <Dialog
      open={open}
      onClose={() => {}} // Prevent closing
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      hideBackdrop={false}
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
          background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
        },
      }}
    >
      <DialogTitle
        sx={{
          textAlign: 'center',
          pb: 1,
          background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a24 100%)',
          color: 'white',
          borderRadius: '12px 12px 0 0',
          fontWeight: 600,
          fontSize: '1.25rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
        }}
      >
        <SecurityIcon sx={{ fontSize: '1.5rem' }} />
        Session Already Active
      </DialogTitle>

      <DialogContent sx={{ p: 3 }}>
        <Stack spacing={3} sx={{ mt: 1 }}>
          {/* Main content with icon */}
          <Box sx={{ textAlign: 'center' }}>
            <Paper
              elevation={0}
              sx={{
                p: 3,
                borderRadius: 2,
                background: 'linear-gradient(135deg, #ffe6e6 0%, #fff0f0 100%)',
                border: '1px solid rgba(255, 107, 107, 0.1)',
              }}
            >
              <ComputerIcon
                sx={{
                  fontSize: '3rem',
                  color: '#ff6b6b',
                  mb: 2,
                }}
              />
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 600,
                  color: '#2c3e50',
                  mb: 1,
                }}
              >
                You're logged in on another browser
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: '#5a6c7d',
                  lineHeight: 1.6,
                }}
              >
                Each account can only be used on one browser at a time. This is
                to prevent account sharing
              </Typography>
            </Paper>
          </Box>

          {/* Warning alert */}
          <Alert
            severity="warning"
            icon={<WarningIcon />}
            sx={{
              borderRadius: 2,
              '& .MuiAlert-message': {
                fontSize: '0.9rem',
              },
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              Need Help?
            </Typography>
            <Typography variant="body2" sx={{ mt: 0.5 }}>
              If you think this is an error or need assistance, please contact
              us at{' '}
              <Box
                component="a"
                href="mailto:boardexamapp@gmail.com"
                sx={{
                  color: 'primary.main',
                  textDecoration: 'none',
                  fontWeight: 'inherit',
                  fontSize: 'inherit',
                  '&:hover': {
                    textDecoration: 'underline',
                  },
                }}
              >
                boardexamapp@gmail.com
              </Box>
            </Typography>
          </Alert>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default OnlyOneBrowserModal;
